import { scaleTime, TimeScale } from './scaleTime';

export const formatDurationMicros = (tickValue: number, decimalPlaces?: number): string => {
    const { value, scale } = scaleTime(tickValue, TimeScale.Microseconds, decimalPlaces);
    return parseFloat(value.toString()).toString() + scale;
};
